// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3JYzZ","label":"Completed_label__2xm-v"};